/** The icon sizes of the app, in pixels. Every icon takes one of these. */
export const ICON_SIZE = {
  xs: 12,
  sm: 14,
  md: 16,
  lg: 18,
  xl: 20,
  xxl: 28,
} as const;
